import { render } from "./Cancelled.vue?vue&type=template&id=057c33ac"
import script from "./Cancelled.vue?vue&type=script&lang=js"
export * from "./Cancelled.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/order-confirm-crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__